import { computed } from 'vue';
import store from '@/store';

export default class LoadingAnimationComponent {
	public progress = computed((): number => {
		const details = store.getters.loadingDetails();
		return (details.batchesLoaded / details.batchesTotal) * 100;
	});
}
